export default function getDocumentAsCompressed(filename = "trinh-duyet.docx") {
  return new Promise(function(resolve, reject) {
    Office.context.document.getFileAsync(
      Office.FileType.Compressed, // Chỗ này có thể đổi thành PDF hay Text
      { sliceSize: 65536 /*64 KB*/ },
      function(result) {
        if (result.status == "succeeded") {
          // If the getFileAsync call succeeded, then
          // result.value will return a valid File Object.
          var myFile = result.value;
          var sliceCount = myFile.sliceCount;
          var slicesReceived = 0,
            gotAllSlices = true,
            docdataSlices = [];
          console.log("File size:" + myFile.size + " #Slices: " + sliceCount);

          // Get the file slices.
          getSliceAsync(
            myFile,
            0,
            sliceCount,
            gotAllSlices,
            docdataSlices,
            slicesReceived
          );
        } else {
          reject(result.error);
        }
      }
    );

    function onGotAllSlices(docdataSlices) {
      try {
        let docdata = [];
        for (var i = 0; i < docdataSlices.length; i++) {
          docdata = docdata.concat(docdataSlices[i]);
        }

        // Convert DocData to File Object
        const newFile = new Blob([new Uint8Array(docdata)], {
          type:
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });

        newFile.name = filename;
        newFile.lastModifiedDate = new Date();

        resolve(newFile);
        // return newFile;

        // OR convert DocData to String
        // var fileContent = new String();
        // for (var j = 0; j < docdata.length; j++) {
        //   fileContent += String.fromCharCode(docdata[j]);
        // }

        // Now all the file content is stored in 'fileContent' variable,
        // you can do something with it, such as print, fax...
      } catch (error) {
        reject(error);
      }
    }

    function getSliceAsync(
      file,
      nextSlice,
      sliceCount,
      gotAllSlices,
      docdataSlices,
      slicesReceived
    ) {
      file.getSliceAsync(nextSlice, function(sliceResult) {
        if (sliceResult.status == "succeeded") {
          if (!gotAllSlices) {
            // Failed to get all slices, no need to continue.
            // const error = new Error("Failed to get all slices");
            // reject(error);
            return;
          }
          try {
            // Got one slice, store it in a temporary array.
            // (Or you can do something else, such as
            // send it to a third-party server.)
            docdataSlices[sliceResult.value.index] = sliceResult.value.data;
            if (++slicesReceived == sliceCount) {
              // All slices have been received.
              file.closeAsync();
              onGotAllSlices(docdataSlices);
            } else {
              getSliceAsync(
                file,
                ++nextSlice,
                sliceCount,
                gotAllSlices,
                docdataSlices,
                slicesReceived
              );
            }
          } catch (error) {
            reject(error);
          }
        } else {
          gotAllSlices = false;
          file.closeAsync();
          reject(sliceResult.error);
        }
      });
    }
  });
}
